import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { Role } from '@/types/user';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  roleId: string;
  roleData: Partial<Role>;
};

export const updateRole = async (
  scope: RequestScope,
  { roleId, roleData }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Role>> => {
  try {
    const response = await scopedApi(scope).put<EndpointResponse<Role>>(`/organization/role/${roleId}`, roleData, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
